// Santa Clara University's undergraduate majors (#2652, founder 2026-09-30:
// "majors offered by the college in the public page"). Read on 2026-10-01
// from SCU's official Undergraduate Bulletin 2026-27, the Undergraduate
// Degrees page of each school (chapters 3, 4 and 5), which names every major
// in one sentence per degree: "confers the degree of bachelor of arts in ...",
// "bachelor of science in ...", "bachelor of science in commerce with majors
// in ...". The Bulletin spells the degrees out; BA, BS and "BS in Commerce"
// are those names shortened. Chemistry and Individual Studies are offered as
// both a BA and a BS in Arts and Sciences; Economics and Individual Studies
// also appear under Business, which confers its own degree. Group notes
// quote SCU's First-Year Students page (the college file's `firstYear`
// source). Minors left out. The KB's list was the starting point; the
// Bulletin wins.
const majors = {
    "slug": "santa-clara-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Santa Clara's official Undergraduate Bulletin 2026-27, grouped by the school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "SCU Undergraduate Bulletin 2026-27, College of Arts and Sciences, Undergraduate Degrees",
                "url": "https://www.scu.edu/bulletin/undergraduate/chapter-3-college-of-arts-and-sciences/undergraduate-degrees.html"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Child Studies",
                    "degree": "BS"
                },
                {
                    "name": "Classics and Ancient Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BS"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Individual Studies",
                    "degree": "BA"
                },
                {
                    "name": "Individual Studies",
                    "degree": "BS"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                }
            ],
            "note": "For natural science applicants, readiness at the level of calculus is expected.",
            "noteSource": "firstYear"
        },
        {
            "name": "Leavey School of Business",
            "source": {
                "label": "SCU Undergraduate Bulletin 2026-27, Leavey School of Business, Undergraduate Degrees",
                "url": "https://www.scu.edu/bulletin/undergraduate/chapter-4-leavey-school-of-business/undergraduate-degrees.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Accounting and Information Systems",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Economics",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Finance",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Individual Studies",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Management",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BS in Commerce"
                },
                {
                    "name": "Marketing",
                    "degree": "BS in Commerce"
                }
            ],
            "note": "For applicants, readiness at the level of calculus is expected.",
            "noteSource": "firstYear"
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "SCU Undergraduate Bulletin 2026-27, School of Engineering, Undergraduate Degrees",
                "url": "https://www.scu.edu/bulletin/undergraduate/chapter-5-school-of-engineering/undergraduate-degrees.html"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "General Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Web Design and Engineering",
                    "degree": "BS"
                }
            ],
            "note": "For applicants, readiness at the level of calculus is expected.",
            "noteSource": "firstYear"
        }
    ]
};

export default majors;
